import { FormFieldControl, Select, Toggle } from "@components";
import type { Key } from "react";
import { cx } from "@/utils/cx";
import { mapDriverLookupToSelectItems } from "../handlers/map-driver-lookup-to-select-items";
import type { InfractionDriverLookupApiResponse } from "../types/infraction-api.types";
import { InfractionSelectedDriverCard } from "./infraction-selected-driver-card";

type InfractionCreateDriverSectionProps = {
	drivers: InfractionDriverLookupApiResponse[];
	selectedDriver: InfractionDriverLookupApiResponse | undefined;
	isPending: boolean;
	transferPointsToDriver: boolean;
	onDriverSearchChange: (value: string) => void;
	onDriverSelect: (driverId: number) => void;
	onRemoveDriver: () => void;
	onTransferPointsChange: (value: boolean) => void;
};

export function InfractionCreateDriverSection({
	drivers,
	selectedDriver,
	isPending,
	transferPointsToDriver,
	onDriverSearchChange,
	onDriverSelect,
	onRemoveDriver,
	onTransferPointsChange,
}: InfractionCreateDriverSectionProps) {
	const hasSelectedDriver = Boolean(selectedDriver);
	const driverItems = mapDriverLookupToSelectItems(drivers);
	const isComboboxDisabled = isPending || hasSelectedDriver;

	return (
		<section className="flex w-full flex-col gap-4">
			<FormFieldControl
				htmlFor="infraction-driver-picker"
				label="Indicar Condutor"
			>
				<div className="flex w-full flex-col gap-4">
					<div
						className={cx(
							hasSelectedDriver ? "pointer-events-none opacity-30" : ""
						)}
					>
						<Select.ComboBox
							allowsEmptyCollection
							aria-label="Buscar condutor por nome ou CPF"
							className="w-full"
							isDisabled={isComboboxDisabled}
							items={driverItems}
							onInputChange={onDriverSearchChange}
							onSelectionChange={(key: Key | null) => {
								if (key) {
									onDriverSelect(Number(key));
								}
							}}
							placeholder="Digite o nome ou CPF do motorista..."
							selectedKey={
								hasSelectedDriver ? String(selectedDriver?.id ?? "") : null
							}
							shortcut={false}
						>
							{(item) => (
								<Select.Item
									id={item.id}
									isDisabled={item.isDisabled}
									textValue={item.label}
								>
									{item.label}
									{item.supportingText ? ` — ${item.supportingText}` : ""}
								</Select.Item>
							)}
						</Select.ComboBox>
					</div>

					{selectedDriver ? (
						<InfractionSelectedDriverCard
							driver={selectedDriver}
							isDisabled={isPending}
							onRemove={onRemoveDriver}
						/>
					) : null}

					{selectedDriver ? (
						<div className="flex cursor-pointer justify-between gap-2 text-sm">
							<p className="text-sm">
								Os pontos da infração estão sendo transferidos para este
								condutor
							</p>
							<Toggle
								isDisabled={isPending}
								isSelected={transferPointsToDriver}
								onChange={(value) => onTransferPointsChange(value)}
								size="sm"
							/>
						</div>
					) : null}
				</div>
			</FormFieldControl>
		</section>
	);
}
